export default class Utils {

  static getDate(date) {
    return this.toUtc(date).toISOString().substring(0, 10);
  }

  static toUtc(dateTime) {
    return new Date(dateTime.getTime() - dateTime.getTimezoneOffset() * 60000);
  }
}



// WEBPACK FOOTER //
// ./src/util/Utils.js